import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

function RedirectionPieChart({ data }) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div></div>;
  }

  let redirected = 0;
  let notRedirected = 0;

  data.forEach((company) => {
    company.data.forEach((entry) => {
      if (entry.redirection === 0) {
        notRedirected++;
      } else {
        redirected++;
      }
    });
  });

  const totalCalls = redirected + notRedirected;

  const chartData = {
    labels: ["Call Not Transferred", "Call Transferred"],
    datasets: [
      {
        data: [notRedirected, redirected],
        backgroundColor: ["#0e7aed", "#A9A9A9"],
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: { size: 14 },
        },
      },
      title: {
        display: true,
        text: `Call Transfer — Total Calls: ${totalCalls}`,
        font: { size: 18 },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${ctx.raw}`,
        },
      },
    },
  };

  return (
    <div style={{ width: "350px", margin: "2rem auto" }}>
      <Pie data={chartData} options={options} />
    </div>
  );
}

export default RedirectionPieChart;
